import { render, staticRenderFns } from "./AreaPersonale.vue?vue&type=template&id=6899d49b&scoped=true"
import script from "./AreaPersonale.vue?vue&type=script&lang=js"
export * from "./AreaPersonale.vue?vue&type=script&lang=js"
import style0 from "./AreaPersonale.vue?vue&type=style&index=0&id=6899d49b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899d49b",
  null
  
)

export default component.exports